<!--begin::Quick Panel-->
<div
    id="kt_quick_panel"
    class="offcanvas pt-5 pb-10 quick_panel_scroll"
    [ngClass]="extrasQuickPanelOffcanvasDirectionCSSClass"
    [class.offcanvas-on]="showPanelUnitToggle"
>
    <div class="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5">
        <div class="offcanvas-close mt-n1 pe-5">
            <a href="javascript:void(0)" class="btn btn-xs btn-icon kt_quick_panel_close btn-hover-primary" (click)="closetoggle()">
                <i class="ki ki-close icon-xs"></i>
            </a>
        </div>
    </div>

    <div class="hero-image-card p-5">
        <!-- <div>
      <button (click)="formConsole()">form</button>
    </div> -->
        <!-- <div class="col-md-12">
            <div class="card card-custom card-stretch">
                <div class="card-body">
                </div>
            </div>
        </div> -->
        <div>
            <h4>{{ 'SETTING_PAGE.INFORMATE_SETTINGS.DEFAULTS_TAB.UNITS' | transloco }}:</h4>
            <!-- {{defaultUnitOptions  | json}} -->
            <div [formGroup]="informateSettingsForm" class="row" *ngIf="defaultUnitOptions != undefined">
                <div class="col-4 mb-5">
                    <mat-label class="font-style">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.DEFAULTS_TAB.METRIC' | transloco }} :</mat-label>
                </div>
                <div class="col-8 mb-5 toggle-wrap">
                    <mat-slide-toggle name="metric" [checked]="defaultUnitMetric" (change)="changeDefault($event)"></mat-slide-toggle>
                </div>

                <div class="col-4 mb-5">
                    <mat-label class="font-style">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.DEFAULTS_TAB.IMPERIAL' | transloco }} :</mat-label>
                </div>
                <div class="col-8 mb-5 toggle-wrap">
                    <mat-slide-toggle name="imperial" [checked]="defaultUnitImperial" (change)="changeDefault($event)"></mat-slide-toggle>
                </div>

                <div class="col-12">
                    <mat-label class="font-style">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.DEFAULTS_TAB.CUSTOM' | transloco }} :</mat-label>
                </div>

                <div class="col-md-12 mb-5">
                    <div class="mb-4" *ngFor="let item of defaultUnitOptions; trackBy: trackById">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 pd-8-15">
                                <mat-label class="font-style">{{ item.setting.name }}</mat-label>
                            </div>
                            <div class="col-xl-6 col-lg-6 method-select-btn">
                                <div class="btn-group custom-toggle-wrap" role="group">
                                    <label
                                        *ngFor="let opt of getOtionbyKeys(item?.setting?.key)"
                                        class="btn custom-toggle"
                                        [class.active]="informateSettingsForm.get(item.setting.key)?.value === opt.value"
                                    >
                                        <input
                                            type="radio"
                                            class="btn-check"
                                            [formControlName]="item.setting.key"
                                            [value]="opt.value"
                                            (change)="onRadioChange(opt.value)"
                                            autocomplete="off"
                                        />

                                        {{ opt.label }}
                                    </label>
                                </div>

                                <!-- <p-selectButton [options]="getOtionbyKeys(item?.setting?.key)"
                                    [formControlName]="item.setting.key" (onOptionClick)="changeOption($event)"
                                    optionLabel="label" optionValue="value"></p-selectButton> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 mb-15 d-flex justify-content-center">
                    <button class="btn primary-ebtn" (click)="saveSettingsOutputHandler()">save</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end::Quick Panel-->
